import React from 'react';
import HTMLReactParser from 'html-react-parser';
import { useStaticQuery, graphql } from "gatsby";
import { Container, Row, Col } from 'react-bootstrap';
import { PhoneIconwhite, EnvelopeIconWhite, WhatsAppIconGreen } from "../Icons/Icons";
import ImageTransform from "../common/ggfx-client/module/components/image-transform";
import { Link } from "@StarberryUtils";
import { useLocation } from "@reach/router";
import LocationMap from '../map/google/LocationMap';
import ImageModule from '../common/Image_Module';
import "./OfficeListings.scss";

const OfficeListings = (props) => {
  
  const data = useStaticQuery(graphql`
    query {
      glstrapi {
        offices(sort: "Sort:asc", where: { Publish: true }) {
          id
          URL
          OfficeName
          TileImage {
            alternativeText
            url
          }
          Address
          Latitude
          Longtitude
          Phone
          Email
          Whatsapp
        }
      }
    }
  `);

  const offices = data.glstrapi.offices || [];
  
  const location = useLocation();
  const location_link = process.env.GATSBY_SITE_URL + location.pathname;

  const officeLocations = offices.map(office => ({
    lat: parseFloat(office.Latitude),
    lng: parseFloat(office.Longtitude),
    title: office.OfficeName,
    address: office.Address,
    url: `/contact/${office.URL}/`,
    image: [{ 
      url: office.TileImage?.url,
      alt: office.TileImage?.alternativeText || `${office.OfficeName} Office Image`
    }],
  }));

  return (
    <>
    <div className="office-listings sec-pdb-120">
      <Container>
        <Row>
          {offices.map((office) => {
            const { id, URL, OfficeName, TileImage, Address, Phone, Email, Whatsapp } = office;
            const number = Phone || '+971 50 882 6124';
            const WhatsappNumber = Whatsapp || '+971 50 882 6124';
            const whatsapp_link = `https://wa.me/${WhatsappNumber}?text=Hello!%20I%20want%20to%20know%20more%20about%20${location_link}`;

            // Check for image transformation data
            let processedImages = JSON.stringify({});
            if (office?.imagetransforms?.TileImage_Transforms) {
              processedImages = office.imagetransforms.TileImage_Transforms;
            }

            return (
              <Col md={6} key={id}>
                <div className="office-card-item">
                  <div className="office-img img-zoom">
                    {TileImage && (
                     <Link href={`/contact/${URL}/`}>
                      {/* <ImageTransform
                        imagesources={TileImage.url}
                        renderer="srcSet"
                        imagename="offices.TileImage.tile"
                        attr={{ alt: `${TileImage.alternativeText} - Dacha` }}
                        imagetransformresult={processedImages}
                        id={id}
                      /> */}
                      <ImageModule 
                            ImageSrc={TileImage} 
                            attr={{ alt: TileImage.alternativeText + ' - Dacha', class: '' }} 
                            ggfx_results={office?.ggfx_results} 
                            imagename="offices.TileImage.tile"
                            strapi_id={id} 
                        />  
                      </Link> 
                    )}
                  </div>
                  <div className="office-info">
                    <h5><Link href={`/contact/${URL}/`}>{OfficeName}</Link></h5>
                    {Address && (
                      <div className="office-address text-sm">
                        {HTMLReactParser(Address.replace(/<br\s*\/?>/gi, ''))}
                      </div>
                    )}
                    <div className="office-contact-details">
                      <Link href={`tel:${number}`} className="text-sm">
                        <span><PhoneIconwhite className="icon-contact-info" /></span>
                        <span className="icon-contact-text">{number}</span>
                      </Link>

                      {Email && (
                        <Link href={`mailto:${Email}`} className="text-sm">
                          <span><EnvelopeIconWhite className="icon-contact-info" /></span>
                          <span className="icon-contact-text">{Email}</span>
                        </Link>
                      )}

                      <Link href={whatsapp_link} className="text-sm" target="_blank">
                        <span><WhatsAppIconGreen className="icon-contact-info" /></span>
                        <span className="icon-contact-text">WhatsApp</span>
                      </Link>
                    </div>
                    <div className="btn-wrapper">
                      <Link href={`/contact/${URL}/`} className="btn btn-outline btn-outline-dark">
                        View Office Details
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </Container>
    </div>
    <div className="office-map">
      <LocationMap lat={25.075464} lng={55.139645} locations={officeLocations} height={"600px"} />
    </div>
   </>
  );
};

export default OfficeListings;